export default __webpack_public_path__ + "static/media/src_img_4.78d9a0b8.png";